import React from 'react'
import PropTypes from 'prop-types'

import * as styles from './styles'

const FlipCardComponent = ({ data, renderFront, renderBack }) => (
  <div css={styles.card}>
    <div css={styles.cardInner}>
      <div css={styles.cardFront}>{renderFront(data)}</div>
      <div css={styles.cardBack}>{renderBack(data)}</div>
    </div>
  </div>
)

FlipCardComponent.propTypes = {
  data: PropTypes.any,
  renderFront: PropTypes.func.isRequired,
  renderBack: PropTypes.func.isRequired,
}

export default FlipCardComponent
